export const TemplateTypes = {
    SET_ADDFIELD : 'SET_ADDFIELD_TEMPLATE_BUILDER',
    SET_FIELD_PROP : 'SET_FIELD_PROP_TEMPLATE_BUILDER',
    CLEAN_FIELD_PROP : 'CLEAN_FIELD_PROP_TEMPLATE_BUILDER',
    SET_SELECTED : 'SET_SELECTED_TEMPLATE_BUILDER',
    SET_CONTENT : 'SET_CONTENT_TEMPLATE_BUILDER',
    LOAD_CONTENT : 'LOAD_CONTENT_TEMPLATE_BUILDER',
    SET_NUMPAGES : 'SET_NUMPAGES_TEMPLATE_BUILDER',
    SET_MIN_NUMPAGES : 'SET_MIN_NUMPAGES_TEMPLATE_BUILDER',
    RESET : 'RESET',
};